"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfilePages = void 0;
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var api_1 = __importStar(require("api"));
var use_stores_1 = require("hooks/use-stores");
var use_notification_1 = require("../../hooks/use-notification");
var Notification_1 = require("../Notification");
var ProfileMenu_1 = __importDefault(require("./ProfileMenu"));
var ProfileBasic_1 = __importDefault(require("./ProfileBasic"));
var ProfilePassword_1 = __importDefault(require("./ProfilePassword"));
var ProfilePages;
(function (ProfilePages) {
    ProfilePages["BASIC_INFO"] = "basicInfo";
    ProfilePages["CHANGE_PASSWORD"] = "changePassword";
})(ProfilePages = exports.ProfilePages || (exports.ProfilePages = {}));
var Profile = mobx_react_1.observer(function () {
    var _a = react_1.useState(ProfilePages.BASIC_INFO), page = _a[0], setPage = _a[1];
    var userStore = use_stores_1.useStores().userStore;
    var notification = use_notification_1.useNotification();
    react_1.useEffect(function () {
        document.title = 'Shop CMS - Profile';
    }, []);
    var changePageHandler = function (newPage) {
        setPage(newPage);
    };
    var changeDetailHandler = function (name, value) {
        var _a;
        api_1.default.editSelf((_a = {},
            _a[name] = value,
            _a))
            .then(function (response) {
            userStore.setData(response.data);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: 'Details have been saved'
            });
        })
            .catch(api_1.catchHandler);
    };
    var passwordSubmitHandler = function (passwordData) {
        var error = null;
        if (passwordData.newPassword && passwordData.newPassword !== passwordData.confirmPassword)
            error = 'Your passwords do not match';
        if (passwordData.newPassword && passwordData.newPassword.length < 8)
            error = 'Password must be at least 8 characters';
        if (!passwordData.newPassword || passwordData.newPassword.length <= 0)
            error = 'Please enter a new password';
        if (error) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: error
            });
            return;
        }
        api_1.default.changePassword(passwordData)
            .then(function () {
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: 'Password has been changed'
            });
        })
            .catch(api_1.catchHandler);
    };
    return (react_1.default.createElement("div", { className: 'page thin-scroll settings' },
        react_1.default.createElement("div", { className: 'settings__title-band' },
            react_1.default.createElement("h1", null, "Profile")),
        react_1.default.createElement("div", { className: 'settings__content flex flex-row' },
            react_1.default.createElement(ProfileMenu_1.default, { page: page, onChangePage: changePageHandler }),
            react_1.default.createElement("div", { className: 'settings__items' },
                page === ProfilePages.BASIC_INFO &&
                    react_1.default.createElement(ProfileBasic_1.default, { data: userStore.data, onChange: changeDetailHandler }),
                page === ProfilePages.CHANGE_PASSWORD &&
                    react_1.default.createElement(ProfilePassword_1.default, { onSubmit: passwordSubmitHandler })))));
});
exports.default = Profile;
